export default (state = { totalShades: 0, shadesRowPerPage: 10, shadesPage: 0 }, { type, payload }) => {
  switch (type) {
    case 'SET_PRODUCT': {
      return payload;
    }
    default:
      return state;
  }
};
